<template>
    <div class="m-confirmationWindow">
        <div class="modal show m-confirmationWindow__modal">
            <div role="document" class="modal-dialog modal-dialog-centered">
                <div class="modal-content m-confirmationWindow__modal-content">
                    <div class="modal-header border-0 text-center pt-4 pb-2">
                        <button
                            @click="$store.dispatch('closeConfirmationWindow')"
                            class="close modal-close"
                        >
                            <span>×</span>
                        </button>
                        <div class="modal-title">
                            <h2
                                class="h3 m-0 p-0"
                                v-html="
                                    confirmationWindowConfig.header || 'Uwaga!'
                                "
                            ></h2>
                        </div>
                    </div>
                    <page-preloader
                        mode="wrapper"
                        :is-loading="isConfirmationWindowLoading"
                    >
                        <template
                            v-if="
                                isConfirmationWindowLoading &&
                                    confirmationWindowConfig.confirmationWindowLoadingText
                            "
                            v-slot:loaderDescription
                        >
                            <div class="py-4">
                                <h5 v-text="confirmationWindowConfig.confirmationWindowLoadingText" />
                            </div>
                        </template>
                        <div class="modal-body pb-3 px-3 text-primary">
                            <p
                                class="typo text-center mb-4"
                                v-html="
                                    confirmationWindowConfig.message ||
                                        'Czy potwierdzasz operację?'
                                "
                            ></p>

                            <div
                                class="
                                    text-center
                                    m-confirmationWindow__buttons
                                "
                            >
                                <button
                                    class="
                                        btn btn-outline-custom
                                        m-1
                                        m-confirmationWindow__button
                                    "
                                    @click="onAbort"
                                    data-dismiss="modal"
                                >
                                    {{
                                        confirmationWindowConfig.abortButtonText ||
                                            'Anuluj'
                                    }}
                                </button>
                                <button
                                    class="
                                        btn btn-secondary
                                        m-1
                                        m-confirmationWindow__button
                                    "
                                    @click="onConfirm"
                                    data-dismiss="modal"
                                >
                                    {{
                                        confirmationWindowConfig.confirmButtonText ||
                                            'Potwierdź'
                                    }}
                                </button>
                            </div>
                        </div>
                    </page-preloader>
                </div>
            </div>
        </div>
        <div class="modal-backdrop show"></div>
    </div>
</template>

<script>
export default {
    computed: {
        confirmationWindowConfig() {
            return this.$store.getters.confirmationWindowConfig
        }
    },
    methods: {
        async onAbort() {
            if (this.confirmationWindowConfig.abortButtonCallback) {
                this.isConfirmationWindowLoading = true
                await this.confirmationWindowConfig.abortButtonCallback()
                this.isConfirmationWindowLoading = false
            }
            this.$store.dispatch('closeConfirmationWindow')
        },
        async onConfirm() {
            if (this.confirmationWindowConfig.confirmButtonCallback) {
                this.isConfirmationWindowLoading = true
                await this.confirmationWindowConfig.confirmButtonCallback()
                this.isConfirmationWindowLoading = false
            }
            this.$store.dispatch('closeConfirmationWindow')
        }
    },
    data() {
        return {
            isConfirmationWindowLoading: false
        }
    }
}
</script>
